export default __webpack_public_path__ + "static/media/img--section.a8236e6c.jpg";